var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iFilter',{attrs:{"label":"Document Types","options":_vm.options,"value":_vm.value},on:{"selection-changed":_vm.onSelectionChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }